'use client';

import { Button, cn, useRequest } from '@wk/wk-uni-lib';

import { useLanguage } from '@/hooks/use-language';
import { getLanguage } from '@/utils/dictionary';
import ErrorGrayBg from 'public/images/common/error-gray.svg';
import ErrorWhiteBg from 'public/images/common/error-white.svg';

export interface ErrorProps {
  error?: Error & { digest?: string };
  reset?: () => void;
  className?: string;
  bgColor?: 'white' | 'gray';
}

export default function Error({
  error,
  reset,
  className,
  bgColor,
}: ErrorProps) {
  const { currentLanguage } = useLanguage();
  const params = Promise.resolve({ lang: currentLanguage });
  const { data: dictionary } = useRequest(() => getLanguage(params, 'common'), {
    refreshDeps: [currentLanguage],
  });

  if (!dictionary) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex items-center justify-center',
        bgColor === 'white' ? 'bg-white' : 'bg-[#F4F4EF]',
        className,
      )}>
      <div className="max-w-[600px] text-center">
        {bgColor === 'white' ? (
          <ErrorWhiteBg className="mb-3 inline-block" />
        ) : (
          <ErrorGrayBg className="mb-3 inline-block" />
        )}
        <p className="mb-4">{dictionary['500-描述']}</p>
        <div>
          <Button onClick={() => window.location.reload()} className="mr-1">
            {dictionary['重试']}
          </Button>
        </div>
      </div>
    </div>
  );
}
